import React, { useState, useEffect } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Typography
} from '@mui/material';
import { adminApi } from '../../services/api';

const ParametersTable = () => {
    const [parameters, setParameters] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchParameters = async () => {
            try {
                const response = await adminApi.getParameters();
                setParameters(response.data);
            } catch (error) {
                console.error('Error fetching parameters:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchParameters();
    }, []);

    if (loading) {
        return <Typography>Loading parameters...</Typography>;
    }

    return (
        <TableContainer component={Paper}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Parameter Name</TableCell>
                        <TableCell>Value</TableCell>
                        <TableCell>Actions</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {parameters.map((param) => (
                        <TableRow key={param.id}>
                            <TableCell>{param.parameter_name}</TableCell>
                            <TableCell>{param.parameter_value}</TableCell>
                            <TableCell>
                                {/* Add edit/delete actions here */}
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default ParametersTable; 